import { render, staticRenderFns } from "./AgreementList.vue?vue&type=template&id=46904fcf&scoped=true&"
import script from "./AgreementList.vue?vue&type=script&lang=js&"
export * from "./AgreementList.vue?vue&type=script&lang=js&"
import style0 from "./AgreementList.vue?vue&type=style&index=0&id=46904fcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46904fcf",
  null
  
)

export default component.exports